

/*/ PRUEBAS  
const URL       = "https://www.ipmaltamira.com.mx:3004/auto2024/";                   
const URLSOCKET = "https://www.ipmaltamira.com.mx:3004/";
const URL_CALC  = "https://www.ipmaltamira.com.mx/TESTREST_STORAGE/api/";
//*/
//  PRODUCCION 
const URL   = "https://www.ipmaltamira.com.mx:3004/auto2024/";      //"http://172.100.100.96:3005/auto2024/";                   
const URLSOCKET = "https://www.ipmaltamira.com.mx:3004/";           //"http://172.100.100.96:3005";
const URL_CALC = "https://www.ipmaltamira.com.mx/REST_STORAGE/api/";//"http://172.100.100.96/REST_STORAGE/api/";
//*/

/*/* Entorno de prubas ip dev  * /
const URL_LOGIN_SUCURSALES     = "http://147.135.90.23:8080/rest/auth/login";
const URL_CONSULTAR_SUCURSALES = "http://147.135.90.23:8080/rest/request/customerinfo/";
const URL_CONSULTAR_BALANCE = 'http://147.135.90.23:8080/rest/request/agent/balance/';
/*--END IP´S dev*/

/*HTTP ip produccion /
const URL_LOGIN_SUCURSALES     = "http://135.148.86.56/rest/auth/login";//"http://147.135.90.23:8080/rest/auth/login";
const URL_CONSULTAR_SUCURSALES = "http://135.148.86.56/rest/request/customerinfo/";//"http://147.135.90.23:8080/rest/request/customerinfo/";
const URL_CONSULTAR_BALANCE = 'http://135.148.86.56/rest/request/agent/balance/';
/*--END IP´S PROD*/

//HTTPS produccion /
    const URL_LOGIN_SUCURSALES     = "https://aurorasa.facturacionipmaltamira.com.mx/rest/auth/login";//"http://147.135.90.23:8080/rest/auth/login";
    const URL_CONSULTAR_SUCURSALES = "https://aurorasa.facturacionipmaltamira.com.mx/rest/request/customerinfo/";//"http://147.135.90.23:8080/rest/request/customerinfo/";
    const URL_CONSULTAR_BALANCE = 'https://aurorasa.facturacionipmaltamira.com.mx/rest/request/agent/balance/';
/*--END IP´S PROD*/

const LOGIN = "login";
const UPPASSMAIL = "upPassMail";
const SEARCH_CONTAINER = "Container/SearchContainer" 
const SEARCH_COMPANY = "Company/SearchCompany";
const GENERATE_TARIFA = "Calc/GenerateTarif";

const GETREFERENCESBYUSER = "getReferencesByUser";
const GETREFERENCEBYID = "getReferenceById";

const GETDOCUMENTSBYUSER = "getDocumentsByUser";
const GETDOCUMENTBYID = "getDocumentById";

const SEND_CALC = "Bill/SendCalc";

const SENDREFERENCE = "sendReference";
const GETREFERENCESRESUME = "getReferencesResume";

const GETDOCUMENTCATALOG = "getDocumentCatalog";
const GETVESSELITINERARY = 'getVesselItinerary';

const SAVEUPDATEREFERENCE = "saveUpdateReference"; 
const SAVEUPDATEDOCUMENT = "saveUpdateDocument";
const GETCALCSUMARYS = "Calc/GetCalcSumarys";
const SEARCHCOMPANY = "searchCompany";
 
const CLOSEREFERENCE = "closeReference"; 

const GETREPORT = "Bill/GetReport";
 
const USER = "CLIENTWS";
const PSW  = "adminf$2023";
 
export  { 
    URL, 
    URL_LOGIN_SUCURSALES,
    URL_CONSULTAR_BALANCE,
    URL_CONSULTAR_SUCURSALES, 
    URL_CALC,

    USER,
    LOGIN,
    UPPASSMAIL,

    PSW,   
    URLSOCKET, 
    GETREPORT, 
    CLOSEREFERENCE,
    GETDOCUMENTSBYUSER, 
    GETCALCSUMARYS, 
    GETDOCUMENTBYID, 
    GENERATE_TARIFA,
    SEARCH_CONTAINER,
    GETDOCUMENTCATALOG, 
    SENDREFERENCE,
    GETREFERENCESRESUME, 
    SAVEUPDATEDOCUMENT,
    SAVEUPDATEREFERENCE,
    SEARCHCOMPANY,
    SEND_CALC,
    GETREFERENCESBYUSER,
    GETREFERENCEBYID,

    SEARCH_COMPANY, 

    GETVESSELITINERARY 
    }
 